import { useEffect, useState } from "react";
import { getCurrentSeason, peekCurrentSeason } from "../utils/hybridDataLoader";

/**
 * The season the data is in: the latest one with results, not the calendar year (they differ from 1 January until
 * the first race of the new season). Starts from the calendar year, or from the known season once it has been loaded.
 */
export const useCurrentSeason = () => {
  const [season, setSeason] = useState(() => peekCurrentSeason() ?? new Date().getFullYear());

  useEffect(() => {
    let active = true;
    getCurrentSeason().then((value) => {
      if (active) setSeason(value);
    });
    return () => {
      active = false;
    };
  }, []);

  return season;
};
